import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { isPhone } from "utils/isPhone"

const useMyDevicePageRedirect = (hasAssignedDevice: boolean) => {
  const navigate = useNavigate()

  // Only redirect to "My Device" page is the user is on a mobile device and has an assigned vehicle.
  useEffect(() => {
    const isMobileDevice = isPhone()
    if (isMobileDevice && hasAssignedDevice) {
      navigate("/my-device")
    }
  }, [navigate, hasAssignedDevice])
}

export default useMyDevicePageRedirect
